import { formConstants } from '../../../../utils/constants/form-constants';

const EmailNotificationSettingsFormData = (accountFormData, userAccountData) => {
    function buildEmailNotificationSettingsFormData() {
        const {
            ssoEmailNotificationSettingsFields,
            updateNotificationSettingsDataCallbackUrl
        } = accountFormData;

        const {
            formTitle,
            description,
            updatedNotificationSuccessMessage,
            championshipSection,
            channelsSection,
            interestsSection
        } = ssoEmailNotificationSettingsFields;

        const formData = {};

        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.formSubTitle] = description;
        formData[formConstants.updatedNotificationSuccessMessage] = updatedNotificationSuccessMessage;
        formData[formConstants.callBackUrl] = updateNotificationSettingsDataCallbackUrl;
        formData[formConstants.championshipSection] = championshipSection;
        formData[formConstants.channelSection] = channelsSection;
        formData[formConstants.interestSection] = interestsSection;

        return formData;
    }

    return buildEmailNotificationSettingsFormData();
};

export default EmailNotificationSettingsFormData;
